module.exports = __webpack_public_path__ + "static/media/navidad7.0181bd67.jpg";